import type { CalendarDate } from '@internationalized/date';
import {
  CalendarStateContext,
  RangeCalendarStateContext
} from 'react-aria-components';
import { ReactElement, useContext } from 'react';
import { useDateFormatter } from 'react-aria';
import { Select } from '../../base/select/select';
import { SelectItem } from '../../base/select/select-item';

type MonthItem = {
  id: string;
  date: CalendarDate;
  label: string;
};

export function MonthDropdown(): ReactElement {
  const calendarState = useContext(CalendarStateContext);
  const rangeCalendarState = useContext(RangeCalendarStateContext);
  const state = calendarState || rangeCalendarState!;
  const formatter = useDateFormatter({
    month: 'short',
    timeZone: state.timeZone
  });

  // Format the name of each month in the year according to the
  // current locale and calendar system. Note that in some calendar
  // systems, such as the Hebrew, the number of months may differ
  // between years.
  const months: MonthItem[] = [];
  const numMonths = state.focusedDate.calendar.getMonthsInYear(
    state.focusedDate
  );
  for (let i = 1; i <= numMonths; i++) {
    const date = state.focusedDate.set({ month: i });
    months.push({
      id: String(i),
      date,
      label: formatter.format(date.toDate(state.timeZone))
    });
  }

  return (
    <Select
      className="flex-1"
      aria-label="Month"
      style={{ flex: 1, width: 'fit-content' }}
      value={months[state.focusedDate.month - 1]?.id}
      onChange={(key) => {
        if (key) {
          const month = months[(key as number) - 1];
          if (month) {
            state.setFocusedDate(month.date);
          }
        }
      }}
      items={months}
    >
      {(item) => <SelectItem id={item.id}>{item.label}</SelectItem>}
    </Select>
  );
}
